import React,{useState} from 'react'
import { Button, Icon } from 'react-materialize';
import { connect } from 'react-redux';
import { DONE, REPURPOSE_QA, YT_HELPER_SECTION } from '../api/Constants'
import { isAdmin, isCustomer, isSubAdmin, isTeamLead} from '../api/Util'
import ConfirmationDialog from './ConfirmationDialog';
import {moveCardSubStatus} from '../api/CardActions'
const actions = require('../actions');

export default connect(null,actions)(({me,card,refresh,closeModal,section =''}) => {
    if (isCustomer(me) && me.is_active_subscription === 0) {
        return null;
    }

    const [confirmationOpen, setConfirmationOpen] = useState(false);
    let allow = isCustomer(me) || isAdmin(me) || isSubAdmin(me);

    if (card.repurpose_status === REPURPOSE_QA) {
        allow = isAdmin(me) || isSubAdmin(me) || isTeamLead(me);
    }

    if( section === YT_HELPER_SECTION || !allow || card.is_repurpose_complete || !(card.card_status === DONE && (card.repurpose_status === DONE || card.repurpose_status === REPURPOSE_QA) )){
        return "";
    }
    
    return (
        <Button className="btn-danger" icon = {<Icon left>navigate_before</Icon>}
            onClick = {()=> setConfirmationOpen(true)}
        >
            Revision
            <ConfirmationDialog
                onNegative = {()=>setConfirmationOpen(false)}
                onPositive = {()=>{
                    const targetColumnType = "repurpose_editing";
                    const sourceColumnType = card.repurpose_status === "done" ? "repurpose_done" : "repurpose_editing";
                    moveCardSubStatus(
                        card.card_id,
                        "editing",
                        card.repurpose_status,
                        () => { refresh(); closeModal(); },
                        { targetColumnType, sourceColumnType }
                    );
                }}
                confirmationHeader = "Repurpose"
                confirmationDialogId = {"confirm-repurpose-"+card.card_id}
                confirmation = {confirmationOpen}
                confirmationText = {`Moving card "${card.card_title}" to repurpose.\nAre you sure you want to proceed?`}
            />
        </Button>
    );
}
);
